/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import NavItems from "@/components/NavItems";
import Styles from "./index.module.scss";
import { HiChevronUp, HiChevronDown } from "react-icons/hi2";
import { IoLocationSharp } from "react-icons/io5";
import { FiShoppingCart } from "react-icons/fi";
import { IoMdMail } from "react-icons/io";
import { TfiWorld } from "react-icons/tfi";
import Cookies from "js-cookie";
import { PLP_PATTERN, SEARCH_PATTERN } from "@/constants";

export default function WorldWideMenu({ world, visible, setIsHovered }) {
  const router = useRouter();
  const { locale = "" } = router;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!visible) {
      setOpen(false);
    }
  }, [visible]);

  const handleLangChange = (item = {}) => {
    const { fields: { label = "", url = "" } = {} } = item || {};
    Cookies.set("NEXT_LOCALE", label.toLowerCase());
    const newLocale = url.replace("/", "");
    if (PLP_PATTERN.test(router.asPath)) {
      const [cleanPLPPath] = router.asPath.split("?");
      window.location.assign(`/${newLocale}${cleanPLPPath}`);
    } else if (SEARCH_PATTERN.test(router.asPath)) {
      const urlObj = new URL(router.asPath, window.location.origin);
      const searchQuery = urlObj.searchParams.get("search") || "";
      window.location.assign(
        `/${newLocale}/results?search=${encodeURIComponent(searchQuery)}`
      );
    } else {
      window.location.assign(`/${newLocale}${router.asPath}`);
    }
  };

  const {
    items: [
      {
        fields: {
          topNav: [
            {
              fields: {
                navItems: [
                  {
                    fields: {
                      url: worldMenuItemUrl = "/",
                      ariaLabel = "",
                      label: worldMenuItemLabel = "",
                    } = {},
                  } = {},
                ] = [],
                navItems: topNavMenu = [],
              } = {},
            } = {},
          ] = [],
          primaryNav = [],
          bottomNav = {},
        } = {},
      } = {},
    ] = [],
    items: worldItems = [],
  } = world || {};

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`hidden lg:block ${
        visible
          ? "translate-y-0 opacity-100 pointer-events-auto"
          : "-translate-y-full opacity-0 pointer-events-none"
      } ${Styles.worldWideMenuContainer}`}
    >
      <div className="h-[31.8px] bg-[#232323] text-[#b5b5b5]">
        <div className="flex justify-between flex-rows max-w-screen-lg mx-auto px-[10px]">
          <div className="flex px-6 worldwide-primary-nav pt-[6px] text-[#fff]">
            <Link href={worldMenuItemUrl || "/"} legacyBehavior>
              <>
                <TfiWorld size={18} />
                <h4
                  className="text-[13px] font-normal cursor-pointer hover:text-white font-[HelveticaLight, Helvetica, sans-serif] no-underline text-[#bebebe] hover:text-[#fff]"
                  style={{
                    paddingRight: "15px",
                    paddingLeft: "6px",
                    // borderRight: "1px solid #333",
                    // borderLeft: "1px solid #333",
                  }}
                  aria-label={ariaLabel}
                  onClick={() => {
                    setOpen(!open);
                  }}
                >
                  {worldMenuItemLabel}
                </h4>
                {!open ? (
                  <HiChevronDown
                    className="text-[#bebebe] hover:text-[#fff] cursor-pointer"
                    size={20}
                    onClick={() => {
                      setOpen(!open);
                    }}
                  />
                ) : (
                  <HiChevronUp
                    className="text-[#bebebe] hover:text-[#fff] cursor-pointer"
                    size={20}
                    onClick={() => {
                      setOpen(!open);
                    }}
                  />
                )}
              </>
            </Link>
            <div className="ml-[15px] flex">
              {topNavMenu?.slice(1, 3)?.map((item, index) => (
                <div
                  key={item?.sys?.id || index}
                  onClick={() => {
                    handleLangChange(item);
                  }}
                >
                  <div>
                    <h4
                      className={`text-[13px] pr-[7px] pl-[15px] cursor-pointer hover:text-white font-helveticaGroup no-underline ${
                        locale.toUpperCase() ===
                          item?.fields?.label.toUpperCase() &&
                        locale.toUpperCase() === "EN"
                          ? `selected-locale-left selected-locale-color`
                          : locale.toUpperCase() ===
                                item?.fields?.label.toUpperCase() &&
                              locale.toUpperCase() === "VN"
                            ? `text-[#fff] selected-locale-color`
                            : `locale-color`
                      }`}
                      aria-label={item?.fields?.ariaLabel}
                    >
                      {item?.fields?.label.toUpperCase()}
                    </h4>
                    {item?.fields?.label.toUpperCase() === "EN" && (
                      <>
                        <span className="absolute h-[18px] border-r border-white bg-[#232323] text-[#bebebe] top-[6px]"></span>
                        <span className="absolute h-[18px] border-r border-white bg-[#232323] text-[#bebebe] top-[6px]"></span>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-rows text-[#bebebe]">
            {topNavMenu?.slice(3)?.map((item, index) => (
              <Link
                href={item?.fields?.url || "/"}
                key={item?.sys?.id || index}
                locale={item?.fields?.url?.replace("/", "")}
                legacyBehavior
              >
                <>
                  {index === 0 && (
                    <div className="self-center">
                      <IoLocationSharp size={18} />
                    </div>
                  )}
                  {index === 1 && (
                    <div className="self-center">
                      <IoMdMail size={18} />
                    </div>
                  )}
                  {item?.fields?.mediaItem?.[0]?.fields?.asset?.fields?.file
                    ?.url ? (
                    <a
                      aria-label={item?.fields?.ariaLabel}
                      href={
                        item?.fields?.url
                          ? item.fields.url.startsWith("http://") ||
                            item.fields.url.startsWith("https://")
                            ? item.fields.url
                            : `/${locale}${item.fields.url}`
                          : undefined
                      }
                      target={
                        item?.fields?.openerType === "New Tab"
                          ? "_blank"
                          : "_self"
                      }
                    >
                      <img
                        className="cursor-pointer hover:text-white no-underline h-[28px] hover:!no-underline"
                        style={{
                          paddingRight: "15px",
                          paddingLeft: "6px",
                          paddingTop: "2px",
                          borderRight: "2px solid #333",
                        }}
                        src={
                          item?.fields?.mediaItem?.[0]?.fields?.asset?.fields
                            ?.file?.url
                        }
                        alt={item?.fields?.mediaItem?.fields?.altText || ""}
                      />
                    </a>
                  ) : (
                    <a
                      className="cursor-pointer hover:text-white font-[HelveticaLight, Helvetica, sans-serif] no-underline text-[13px] leading-[30px] font-normal h-[30px] hover:!no-underline"
                      style={{
                        paddingRight: "15px",
                        paddingLeft: "6px",
                        borderRight: "2px solid #333",
                        // borderLeft: "1px solid #333",
                      }}
                      aria-label={item?.fields?.ariaLabel}
                      href={
                        item?.fields?.url
                          ? item.fields.url.startsWith("http://") ||
                            item.fields.url.startsWith("https://")
                            ? item.fields.url
                            : `/${locale}${item.fields.url}`
                          : undefined
                      }
                    >
                      {item?.fields?.label}
                    </a>
                  )}
                </>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className={`accordion-wrapper ${open ? "open" : ""}`}>
        <div className="accordion-inner">
          <div className="accordion-content"></div>
          <section className="max-w-screen-lg mx-auto pl-[2.5rem]">
            <div className="flex justify-between pt-5 ">
              {worldItems.map(item =>
                item?.fields?.primaryNav?.map(i => (
                  <div className="" key={item?.sys?.id}>
                    {i.fields.heading && (
                      <div className="font-[Helvetica-Light,_Helvetica,_sans-serif] flex-nowrap flex leading-[20px] text-[13px] cursor-default lg:pr-[60px]">
                        {i.fields.heading}
                      </div>
                    )}
                    {i?.fields.heading &&
                      i?.fields?.navItems?.map((navItem, index) => (
                        <NavItems
                          key={navItem?.sys?.id || index}
                          navItem={navItem}
                          classNames="hover:text-white text-[#999999] cursor-pointer text-[13px]"
                          linkClass="flex lg:py-[5px] lg:pr-[60px] w-full hover:text-white text-[#999999]"
                        />
                      ))}
                  </div>
                ))
              )}
            </div>
            <hr className="border-t border-[#333] absolute left-0 right-0 bottom-[65px]" />
            <div
              className="flex"
              style={{ color: "#b5b5b5", marginTop: "20px", marginLeft: "4px" }}
            >
              {world?.items
                ? world?.items[0]?.fields?.bottomNav?.fields?.navItems?.map(
                    i => (
                      <ul
                        style={{
                          borderRight: "solid 1px #333",
                          listStyle: "none",
                          textAlign: "left",
                        }}
                        key={i?.fields?.label}
                      >
                        <li>
                          <a
                            href={i.fields.url}
                            target="_blank"
                            rel="noreferrer"
                            style={{ padding: "0px 10px", listStyle: "nono" }}
                          >
                            <img
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px",
                              }}
                              alt={i.fields.mediaItem[0].fields?.altText}
                              aria-label={i.fields.mediaItem[0].fields?.altText}
                              src={
                                i.fields.mediaItem[0].fields.asset.fields.file
                                  .url
                              }
                            />
                          </a>
                        </li>
                      </ul>
                    )
                  )
                : null}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

WorldWideMenu.propTypes = {
  world: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          topNav: PropTypes.arrayOf(
            PropTypes.shape({
              fields: PropTypes.shape({
                navItems: PropTypes.arrayOf(
                  PropTypes.shape({
                    fields: PropTypes.shape({
                      url: PropTypes.string,
                      label: PropTypes.string,
                      ariaLabel: PropTypes.string,
                      sys: PropTypes.shape({
                        id: PropTypes.string,
                      }),
                    }),
                  })
                ),
              }),
            })
          ),
          primaryNav: PropTypes.arrayOf(
            PropTypes.shape({
              fields: PropTypes.shape({
                internalTitle: PropTypes.string,
                navItems: PropTypes.arrayOf(
                  PropTypes.shape({
                    sys: PropTypes.shape({
                      id: PropTypes.string,
                    }),
                    fields: PropTypes.shape({
                      label: PropTypes.string,
                      url: PropTypes.string,
                      ariaLabel: PropTypes.string,
                      mediaItem: PropTypes.arrayOf(
                        PropTypes.shape({
                          fields: PropTypes.shape({
                            altText: PropTypes.string,
                            asset: PropTypes.shape({
                              fields: PropTypes.shape({
                                file: PropTypes.shape({
                                  url: PropTypes.string,
                                }),
                              }),
                            }),
                          }),
                        })
                      ),
                    }),
                  })
                ),
              }),
            })
          ),
          bottomNav: PropTypes.shape({
            fields: PropTypes.shape({
              navItems: PropTypes.arrayOf(
                PropTypes.shape({
                  fields: PropTypes.shape({
                    label: PropTypes.string,
                    url: PropTypes.string,
                    mediaItem: PropTypes.arrayOf(
                      PropTypes.shape({
                        fields: PropTypes.shape({
                          altText: PropTypes.string,
                          asset: PropTypes.shape({
                            fields: PropTypes.shape({
                              file: PropTypes.shape({
                                url: PropTypes.string,
                              }),
                            }),
                          }),
                        }),
                      })
                    ),
                  }),
                })
              ),
            }),
          }),
        }),
      })
    ),
  }),
};
